import styled from "styled-components";
import { Heading1, SubHeading } from "../../../../common/styled-components/styled-components";
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';
import { white, royal, codGrey } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';


export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  ${styledFont("Graphie")}
  padding: 3rem 1.6rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;

`;

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    flex: 1;
    align-items: flex-start;
  }
`;
export const HeadingText = styled(Heading1)`
  width: auto;
  color: ${codGrey};
  padding-top: 3rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  text-align: left;
  margin: 0;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.8, 7)};
    width: 80%;
  }
`;

export const SubHeadingText = styled(SubHeading)`
  width: 100%;
  color: ${royal};
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2, 2.4, 6)}
  text-align: left;
  @media (min-width: ${breakpoints.sm}px) {
    width: auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: auto;
  }
`;

export const ListWrapper = styled.ul`
  padding: 0 0 2.8rem;
  width: auto;
  list-style: none;
  margin: 0;
`;

export const ListItem = styled.li`
  ${styledFont("Graphie", 1.8, 3.6, 4)};
  color: ${props=>props.fColor || white};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2, 3.6, 4)};
  }
  &:before {
    content: ' ';
    width: 1rem;
    height: 1rem;
    background-color: ${props=>props.bulletColor || white};
    display: inline-flex;
    margin-right: 0.8rem;
    border-radius: 50%;
    @media (min-width: ${breakpoints.lg}px) {
      width: 1.2rem;
      height: 1.2rem;

    }
  }
`;

export const ImacSectionWrapper = styled.div`
  > img {
    width: 100%;
    margin-left: -1.6rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex: 2;
  }
`;

export const AppDownloads = styled.div`
  display: flex;
  justify-content: space-between;
  > img {
    width: 16.4rem;
  }
  @media (min-width: ${breakpoints.sm}px) {
    width: 35rem;
    margin: 0 auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: 26rem;
    margin: 0 auto;
    > img {
      width: 12.3rem;
    }
  }
`;